import {
  css
} from 'lit';

export const FooterStyle = css`

.lds-footer {
  padding: calc(3.5rem - 2px) 2rem 3.5rem;
  text-align: center;
  background: var(--lds-color-footer-background);
  border-top: var(--lds-border-footer-width) solid var(--lds-color-footer-top-border);
}

.lds-footer .lds-footer-logo-img,
.lds-footer .lds-footer-logo img {
  margin: auto;
}

.lds-footer .text-nowrap {
  white-space: nowrap;
}

.lds-footer-menu-links {
  padding-bottom: 1rem;
}

.lds-footer-menu-links a {
  display: inline-block;
  margin-bottom: 1rem;
}

.lds-footer-menu-links .h4 {
  margin-bottom: 0.5rem;
  font-weight: var(--lds-typography-font-weight-bold);
}

.lds-footer-menu-links .lds-footer-menu-links-global {
  display: inline-block;
  margin-bottom: 1rem;
  clear: both;
}

.lds-footer-menu-links li {
  display: inline-block;
}

.lds-footer-menu-links .global-content {
  display: contents;
}

.lds-footer-support {
  margin-bottom: 2rem;
  text-align: center;
}

.lds-footer-support p {
  margin-bottom: 0;
}

.lds-footer-meta {
  margin-bottom: 3rem;
}

.lds-footer-meta p {
  margin-bottom: 0;
  font: var(--lds-typography-footer-meta-font);
}

.lds-footer-menu-links-column {
  margin-bottom: 2rem;
}

.lds-footer-menu-links-column li {
  display: block;
}

.lds-footer-menu-links-column a {
  display: inline-block;
  margin-bottom: 1rem;
}

.lds-footer-menu-links-column a:last-child {
  margin-bottom: 1rem;
}

.lds-footer-menu-links-column h4 {
  margin-bottom: 1rem;
  font-weight: var(--lds-typography-font-weight-bold);
}

.lds-footer-social-icons {
  height: 1.5rem;
  margin-bottom: 1.5rem;
  text-align: center;
}

.lds-footer-social-icons a {
  display: inline-block;
  margin-left: 2rem;
}

.lds-footer-social-icons a:first-child {
  margin-left: 0;
}

.lds-footer-social-icons .icon {
  display: block;
  width: 1.5rem;
  height: 1.5rem;
}

.lds-footer-global-links {
  font: var(--lds-typography-footer-meta-font);
  text-align: right;
}

.lds-footer-global-links a {
  display: inline-block;
  margin-left: 2rem;
}

.lds-footer-global-links a:first-child {
  margin-left: 0;
}

@media (min-width: 768px) {
  .lds-footer {
    text-align: left;
  }
  .lds-footer-meta {
    margin-bottom: 1.5rem;
  }
  .lds-footer-support {
    margin-bottom: .5rem;
    text-align: right;
  }
}
`;

export default FooterStyle;
